import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import InfoIcon from '@assets/icons/ic-information.svg';
import { Paragraph } from '../Styled';
import { AlertWrapper } from './Alert.style';
const Alert = ({ message }) => (_jsxs(AlertWrapper, { children: [_jsx("img", { src: InfoIcon, alt: "Icono de informaci\u00F3n" }), _jsx(Paragraph, { children: message })] }));
export default Alert;
